interface CoverImageFallbackOptions {
  fallbackPath?: string
}

export function useCoverImageFallback(
  source: MaybeRefOrGetter<string | null | undefined>,
  options: CoverImageFallbackOptions = {},
) {
  const { fallbackPath = 'images/cover-fallback.svg' } = options
  const coverFallbackImage = usePublicAssetUrl(fallbackPath)
  const isCoverImageFailed = ref(false)

  watch(() => toValue(source), () => {
    isCoverImageFailed.value = false
  })

  const shouldRenderCoverImage = computed(() => {
    return Boolean(toValue(source)) && !isCoverImageFailed.value
  })

  function handleCoverImageError() {
    isCoverImageFailed.value = true
  }

  return {
    coverFallbackImage,
    isCoverImageFailed,
    shouldRenderCoverImage,
    handleCoverImageError,
  }
}

export function useCoverImageFallbackMap(options: CoverImageFallbackOptions = {}) {
  const { fallbackPath = 'images/cover-fallback.svg' } = options
  const coverFallbackImage = usePublicAssetUrl(fallbackPath)
  const failedCoverImageIds = ref(new Set<string>())

  function isCoverImageFailed(itemId: string) {
    return failedCoverImageIds.value.has(itemId)
  }

  function shouldRenderCoverImage(itemId: string, source?: string | null) {
    return Boolean(source) && !isCoverImageFailed(itemId)
  }

  function handleCoverImageError(itemId: string) {
    failedCoverImageIds.value.add(itemId)
  }

  function resetCoverImageError(itemId: string) {
    failedCoverImageIds.value.delete(itemId)
  }

  return {
    coverFallbackImage,
    isCoverImageFailed,
    shouldRenderCoverImage,
    handleCoverImageError,
    resetCoverImageError,
  }
}
